import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    constructor(private http: HttpClient) { }

    getAllClients(body: any): Observable<any> {
        return this.http.post(environment.getAllClients, body);
    }

    createClient(body: any): Observable<any> {
        return this.http.post(environment.createClient, body);
    }

    getClient(body: any): Observable<any> {
        return this.http.post(environment.getClient, body);
    }

    updateClient(body: any): Observable<any> {
        return this.http.post(environment.updateClient, body);
    }

    deleteClient(body: any): Observable<any> {
        return this.http.post(environment.deleteClient, body);
    }
    getAllClientPackage(data: any): Observable<any> {
      return this.http.post(environment.getAllClientPackage, data);
    }

    createClientPackage(data: any): Observable<any> {
      return this.http.post(environment.createClientPackage, data);
    }
    
    updateClientPackage(data: any): Observable<any> {
      return this.http.post(environment.updateClientPackage, data);
    }

    getCounterById(data: any): Observable<any> {
      return this.http.post(environment.getCounterById, data);
    }

    updateCounter(data: any): Observable<any> {
      return this.http.post(environment.updateCounter, data);
    }
    
    createCounter(data: any): Observable<any> {
      return this.http.post(environment.createCounter, data);
    }
    
    createPipeLine(data: any): Observable<any> {
      return this.http.post(environment.createPipeLine, data);
    }
}
